import {Box, DialogContentText} from "@mui/material";
import React from "react";
import WatchOffIcon from "@mui/icons-material/WatchOff";

export default function NoImageView({itemTitle, view}) {

    return (<>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                padding={1}
                className={!view ? "ImageSize" : ""}
                sx={{height: view ? '100%' : undefined, width: '100%', userSelect: 'none'}}
            >
                <WatchOffIcon/>
                <DialogContentText sx={{fontSize: '0.75em'}}>
                    {itemTitle}
                </DialogContentText>
            </Box>
        </>
    );

}